/**
 * English - `storeLocations`: the Store locations screen (the shops a
 * shopper can walk into) and the store locator section's settings.
 */
const storeLocations: Record<string, string> = {
  title: 'Store locations',
  intro: 'The shops people can walk into. Active locations appear in the Store locator section of your storefront, in this order.',
  add: 'Add location',
  loading: 'Loading locations…',
  load_error: 'Your locations could not be loaded. Please refresh the page.',
  empty_title: 'No locations yet',
  empty_description: 'Add your first shop so shoppers can find you, see your opening hours and get directions.',
  read_only: 'You can view the locations but not change them.',
  active: 'Active',
  hidden: 'Hidden',
  hours_listed: 'Opening hours listed',
  no_hours: 'Opening hours not shown',
  has_pin: 'Map pin set',
  move_up: 'Move up',
  move_down: 'Move down',
  edit: 'Edit',
  delete: 'Delete',
  delete_title: 'Delete location',
  delete_confirm: 'Delete {name}? Shoppers will no longer see it. This cannot be undone.',
  saved: 'Location saved.',
  deleted: 'Location deleted.',
  generic_error: 'That did not save. Please try again.',
  'form.add_title': 'Add a location',
  'form.edit_title': 'Edit location',
  'form.details': 'Shop details',
  'form.name': 'Location name',
  'form.address_line1': 'Address',
  'form.address_line2': 'Address line 2',
  'form.city': 'City',
  'form.state': 'State',
  'form.pincode': 'PIN code',
  'form.phone': 'Phone',
  'form.email': 'Email',
  'form.map': 'Map pin',
  'form.coordinates_hint': 'Optional. Without a pin, directions use the address and no map is shown.',
  'form.latitude': 'Latitude',
  'form.longitude': 'Longitude',
  'form.services': 'Services',
  'form.services_placeholder': 'Dine-in, Parking, Takeaway',
  'form.services_hint': 'Separate with commas. Up to 12.',
  'form.is_active': 'Show on the storefront',
  'form.hours': 'Opening hours',
  'form.show_hours': 'List opening hours',
  'form.opens': 'Opens',
  'form.closes': 'Closes',
  'form.closed': 'Closed',
  'form.day.0': 'Monday',
  'form.day.1': 'Tuesday',
  'form.day.2': 'Wednesday',
  'form.day.3': 'Thursday',
  'form.day.4': 'Friday',
  'form.day.5': 'Saturday',
  'form.day.6': 'Sunday',
  'form.save': 'Save location',
  'form.saving': 'Saving…',
  'form.cancel': 'Cancel',
  'errors.required': 'This field is required.',
  'errors.pincode': 'Enter a PIN code of 3 to 10 letters or digits.',
  'errors.phone': 'Enter a phone number with digits, spaces or dashes.',
  'errors.email': 'Enter a valid email address.',
  'errors.coordinates': 'Enter both latitude and longitude, or leave both empty.',
  'errors.latitude': 'Latitude is a number between -90 and 90.',
  'errors.longitude': 'Longitude is a number between -180 and 180.',
  'errors.hours': 'On {day}, closing time must be after opening time.',
  'section.intro': 'Lists your active shops from the Store locations screen - the addresses and hours are kept there, not here.',
  'section.manage': 'Manage store locations',
  'section.layout': 'Layout',
  'section.layout_choice.list': 'List',
  'section.layout_choice.cards': 'Cards',
  'section.layout_choice.list_with_map': 'List with map',
  'section.show_hours': 'Show opening hours and "open now"',
  'section.show_phone': 'Show phone numbers',
  'section.show_directions': 'Show a directions link',
  'section.search': 'Show a search box',
};

export default storeLocations;
